import { codClientes, codNoCliente, codSopladoRD } from '../../../Shared';

export const addCodigosSoplado = (): string[] => {
  const cods = [...new Set([...codClientes, ...codNoCliente, ...codSopladoRD])]
  return cods
}